import classNames from "classnames";
import { Spin } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import ActivityItem from "./item";

const activityLinksConfigType = PropTypes.shape({
  enabled: PropTypes.bool,
  labels: PropTypes.shape({
    project: PropTypes.string,
    contact: PropTypes.string,
  }),
  onOpenProject: PropTypes.func,
  onOpenContact: PropTypes.func,
});

const ActivitiesLog = ({
  activities,
  hasMore,
  onLoadMore,
  loadingMore,
  activityLinks,
  loadMoreLabel,
  loadMoreLoadingLabel,
  onOpenEmail,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTACT);
  const resolvedLoadMore = loadMoreLabel ?? t("ACTIVITIES.LOAD_MORE");
  const resolvedLoading =
    loadMoreLoadingLabel ?? t("ACTIVITIES.LOAD_MORE_LOADING");

  return (
    <div className="activities__log">
      {activities.map((activity, index) => (
        <ActivityItem
          key={
            activity.emailActivity?.id ||
            activity.callData?.id ||
            `${activity.activityType}-${String(activity.date)}-${index}`
          }
          activity={activity}
          activityLinks={activityLinks}
          onOpenEmail={onOpenEmail}
        />
      ))}
      {hasMore && (
        <button
          type="button"
          className={classNames("activities__log--load-more", {
            "activities__log--load-more--disabled": loadingMore,
          })}
          onClick={onLoadMore}
          disabled={loadingMore}
        >
          {loadingMore ? (
            <span className="d-flex align--center justify--center gap-8">
              <Spin size="small" />
              <span>{resolvedLoading}</span>
            </span>
          ) : (
            resolvedLoadMore
          )}
        </button>
      )}
    </div>
  );
};

ActivitiesLog.propTypes = {
  activities: PropTypes.arrayOf(PropTypes.object).isRequired,
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func,
  loadingMore: PropTypes.bool,
  activityLinks: activityLinksConfigType,
  loadMoreLabel: PropTypes.string,
  loadMoreLoadingLabel: PropTypes.string,
  onOpenEmail: PropTypes.func,
};

export default ActivitiesLog;
